<template>
<div class="view list active">
    <div class="view-container">

        <div class="position-relative w-100 h-100">

            <div class="container-fluid">
                <div class="search-area-text mt-1 mb-3">
                    Visar massörer från valt område i kartan
                </div>
            </div>

            <div class="booking-list">
                <div class="booking-list-item" v-for="clinic in clinics" :key="clinic.id" @click="openClinic(clinic.id)">
                    <div class="container-fluid">


                        <div class="d-flex" v-if="clinic.checkbox_multiple_clinics || clinic.practitioners.length > 1">
                            <div class="pt-1">
                                <div class="portrait-wrapper"></div>
                            </div>
                            <div>
                                <h4 class="mb-1 text-primary">{{ clinic.card_name_clinic }}</h4>
                                <span v-if="clinic.survey_score" style="font-weight: 500;" class="me-2"><img src="/images/card/review-heart.svg" style="width: 16px; margin-right: 6px; margin-top: -3px;">{{ clinic.survey_score}}</span>
                                <span v-if="clinic.is_new && !clinic.survey_score" class="badge badge-sm bg-secondary me-1" style="transform: translateY(-2px);">Ny</span>
                                <span style="color:#888;" v-if="currentPosition">
                                    {{ geoDistance(clinic._geoDistance) }} från dig
                                </span>
                                <div style="color:#333;"><span v-if="clinic.address.co">{{ clinic.address.co }}, </span>{{ clinic.address.street }}, {{ clinic.address.city }}</div>
                                <div style="color:#888;"><span :key="'rm'+practitioner.id" v-for="(practitioner, index2) in clinic.practitioners" v-if="practitioner.is_clinic != 1"><span v-if="index2 != 0">, </span>{{ practitioner.name }}</span></div>
                            </div>
                        </div>

                        <div class="d-flex" v-else>
                            <div>
                                <div class="portrait-wrapper" :key="'pw'+practitioner.id" v-for="practitioner in clinic.practitioners" v-if="clinic.practitioners.length < 2">
                                    <img :src="practitioner.thumb_url" class="portrait" v-if="practitioner.thumb_url" />
                                </div>
                                <div class="portrait-wrapper" v-else></div>
                            </div>
                            <div :key="'rs'+practitioner.id" v-for="practitioner in clinic.practitioners">
                                <h4 class="mb-1 text-primary">{{ practitioner.name }}</h4>

                                <span v-if="clinic.survey_score" style="font-weight: 500;" class="me-2"><img src="/images/card/review-heart.svg" style="width: 16px; margin-right: 6px; margin-top: -3px;">{{ clinic.survey_score}}</span>
                                <span v-if="clinic.is_new && !clinic.survey_score" class="badge badge-sm bg-secondary me-1" style="transform: translateY(-2px);">Ny</span>
                                <span style="color:#888;" v-if="currentPosition">
                                    {{ geoDistance(clinic._geoDistance) }} från dig
                                </span>
                                <div style="color:#333;"><span v-if="clinic.address.co">{{ clinic.address.co }}, </span>{{ clinic.address.street }}, {{ clinic.address.city }}</div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import { mapState, mapStores } from 'pinia'
import { useBookingStore } from '../../stores/bookingStore'

export default {
    data () {
        return {

        }
    },
    computed: {
        ...mapStores(useBookingStore),
        ...mapState(useBookingStore, {
            clinics: state => state.clinics,
            currentPosition: state => state.currentPosition,
        }),
        allPractitioners () {
            const practitioners = []
            this.clinics.forEach(clinic => {
                clinic.practitioners.forEach(practitioner => {
                    practitioners.push({
                        clinic_id: clinic.id,
                        survey_score: clinic.survey_score,
                        is_new: clinic.is_new,
                        practitioner: practitioner,
                        _geoDistance: clinic._geoDistance,
                        address: clinic.address
                    })
                })
            })

            return practitioners
        }
    },
    methods: {
        geoDistance (distanceInMeters) {
            if (distanceInMeters < 999) {
                return distanceInMeters + ' meter'
            }

            return (distanceInMeters / 1000).toFixed(1) + ' km'
        },

        openClinic (clinic_id) {
            this.matomoTrackEvent('Booking', 'Open clinic', 'List')

            this.$router.push({ name: 'modal-clinic', params: { clinic: clinic_id } })
        },
    }
}
</script>
